import Vue from "vue"
import Vuetify from "vuetify"
import "vuetify/dist/vuetify.min.css"
import fr from "vuetify/lib/locale/fr"

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#CC4433",
				secondary: "#FFBF00",
				accent: "#82B1FF",
				error: "#FF5252",
				info: "#2196F3",
				success: "#4CAF50",
				warning: "#FFC107",
				background: "#FFFAFA",
			},
		},
	},
	lang: {
		locales: { fr },
		current: "fr",
	},
})
